import { useGet } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';
import { useQueryClient } from '@tanstack/react-query';

const pillarCode = "tms";

export type RepriceReason = string | { reason: string };

export function useRepriceReasons() {
  const get = useGet(true, pillarCode);
  const getRepriceReasons = (): Promise<RepriceReason[]> => get(`${referenceDataBaseUrl}/reprice-reasons`);
  return useQueryWithErrorHandling({
    queryKey: ['reprice-reasons'],
    queryFn: async () => await getRepriceReasons(),
  });
}

export function useRefreshRepriceReasons() {
  const queryClient = useQueryClient();

  return () => queryClient.invalidateQueries({ queryKey: ['reprice-reasons'] });
}
